"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOP_PAYERS_BY_STATE = exports.SELECT_PAYER_GROUPS_CONFIG = exports.LABEL_SEPARATOR = exports.GENERAL_TOP_PAYERS = void 0;
var LABEL_SEPARATOR = ' (';
exports.LABEL_SEPARATOR = LABEL_SEPARATOR;
var GENERAL_TOP_PAYERS = ['AETNA', 'CIGNA', 'OPTUMHEALTH CARE SOLUTIONS', 'UNITED HEALTHCARE'];
exports.GENERAL_TOP_PAYERS = GENERAL_TOP_PAYERS;
var TOP_PAYERS_BY_STATE = {
  NY: ['NEW YORK EMPIRE BLUE SHIELD'],
  CA: ['ANTHEM BLUE CROSS', 'BLUE SHIELD OF CALIFORNIA'],
  TX: ['TEXAS BLUE SHIELD'],
  MD: ['MARYLAND BLUE SHIELD - CAREFIRST'],
  NJ: ['HORIZON BLUE SHIELD OF NEW JERSEY']
};
exports.TOP_PAYERS_BY_STATE = TOP_PAYERS_BY_STATE;
var SELECT_PAYER_GROUPS_CONFIG = {
  POPULAR: {
    label: 'Popular providers'
  },
  ALL: {
    label: 'All providers'
  }
};
exports.SELECT_PAYER_GROUPS_CONFIG = SELECT_PAYER_GROUPS_CONFIG;